import sessionStore from './sessionStore';
import localStore from './localStore';
import dbStore from './dbStore';

// SEE: https://localforage.github.io/localForage/

class EHIStore {
    session;
    local;
    db;

    constructor() {
        this.session = sessionStore;
        this.local = localStore;
        this.db = dbStore;
    }

    getStoreByKey(key) {
        switch (key) {
            case 'mlcWhyInterested' : return this.session;
            case 'mlcTimeUntil65' : return this.session;
            case 'mlcWhenRetiring' : return this.session;
            case 'mlcOtherSituation' : return this.session;
            case 'firstName' : return this.session;
            case 'lastName' : return this.session;
            case 'streetAddress' : return this.session;
            case 'city' : return this.local;
            case 'state' : return this.local;
            case 'zipCode' : return this.local;
            case 'county' : return this.local;
            case 'phone' : return this.session;
            case 'mobile' : return this.session;
            case 'emailAddress' : return this.session;
            case 'canWePhone' : return this.session;
            case 'canWeEmail' : return this.session;
            case 'canWeText' : return this.session;
            case 'melissaData' : return this.session;
            case 'hasVisitedMLC' : return this.session;
            case 'hasShownMLCOfferPopup' : return this.session;
        }

        return null;
    }

    async getItem(key, successCallback) {
        const store = this.getStoreByKey(key);
        
        if (store) {
            return store.getItem(key, successCallback);
        }

        const keys = await this.keys();

        if (keys.session.includes(key)) {
            return this.session.getItem(key, successCallback);
        }

        if (keys.local.includes(key)) {
            return this.local.getItem(key, successCallback);
        }

        if (keys.db.includes(key)) {
            return this.db.getItem(key, successCallback);
        }
        
        return null;
    }

    setItem(key, value, storageType, successCallback) {
        const store = this.getStoreByKey(key);

        if (store) {
            return store.setItem(key, value, successCallback);
        }

        if (storageType == 'session' || storageType == 'sessionStorage') {
            return this.session.setItem(key, value, successCallback);
        }

        if (storageType == 'local' || storageType == 'localStorage') {
            return this.local.setItem(key, value, successCallback);
        }

        if (storageType == 'db' || storageType == 'indexedDB') {
            return this.db.setItem(key, value, successCallback);
        }
        
        return null;
    }
    
    removeItem(key, successCallback) {
        const store = this.getStoreByKey(key);

        if (!store) {
            return null;
        }

        return store.removeItem(key, successCallback);
    }

    clear() {
        this.session.clear();
        this.local.clear();
        this.db.clear();
    }

    async keys(successCallback) {
        const keys = {
            session: await this.session.keys(),
            local: await this.local.keys(),
            db: await this.db.keys()
        };

        return (typeof successCallback == 'function') ? successCallback(keys) : keys;
    }

    async iterate(iteratorCallback, successCallback) {
        if (typeof iteratorCallback !== 'function') {
            return null;
        }

        const stores = {
            session: await this.session.iterate(iteratorCallback),
            local: await this.local.iterate(iteratorCallback),
            db: await this.db.iterate(iteratorCallback)
        };
        
        return (typeof successCallback == 'function') ? successCallback(stores) : stores;
    }

    

    async length(successCallback) {
        const lengths = {
            session: await this.session.length(),
            local: await this.local.length(),
            db: await this.db.length()
        };

        return (typeof successCallback == 'function') ? successCallback(lengths) : lengths;
    }

};

export default EHIStore;